import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '.';
// Models
import {
  AppConstants,
  Email,
  Parameter,
  ParametersResponse,
  PrintResponse,
  Report,
  ReportResponse,
  ReportUsersResponse,
} from '../common/models.index';
import { BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root',
})
export class RptManagerService {
  
  constructor(private http: HttpClient
    , private storageService:StorageService) {}

  SaveReportFile(report: File, _companyKey: number, _appKey: number) {
    const formData = new FormData();
    formData.append('report', report);

    const headers = new HttpHeaders();

    headers.append('Content-Type', 'application/json');

    const httpOptions = {
      headers: headers
  };


    return this.http.post<BaseResponse>(
      `${AppConstants.API_URL}api/Reports/SaveReportFile?companyKey=${_companyKey}&appKey=${_appKey}`,
      formData,httpOptions
    );
  }

  HandlePostOrPutReport(report: Report) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    if (report.Id > 0) {
      return this.http.put<any>(
        `${AppConstants.API_URL}api/Reports/PutReport`,
        report,
        { headers }
      );
    } else {
      return this.http.post<any>(
        `${AppConstants.API_URL}api/Reports/PostReport`,
        report,
        { headers }
      );
    }
  }

  GetReports(companyKey:number,appKey:number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.get<ReportResponse>(
      `${AppConstants.API_URL}api/Reports/GetReports?companyKey=${companyKey}&appKey=${appKey}`,
      { headers }
    );
  }

  GetParameters(reportId: number, _shouldRequestData: boolean = false) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    const URL = _shouldRequestData ? `${AppConstants.API_URL}api/Parameter/GetParameters?reportId=${reportId}&&shouldRequestData=true`: `${AppConstants.API_URL}api/Parameter/GetParameters?reportId=${reportId}`;
    return this.http.get<ParametersResponse>(URL, { headers }
    );
  }

  PrintReport(parameters: Parameter[], reportId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.post<PrintResponse>(
      `${AppConstants.API_URL}api/Reports/PrintReport?reportId=${reportId}`,
      parameters,
      { headers }
    );
  }

  SendEmail(emailInfo: Email, reportId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.post<BaseResponse>(
      `${AppConstants.API_URL}api/Reports/SendEmail?reportId=${reportId}`,
      emailInfo,
      { headers }
    );
  }

  DownloadFile(reportId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.get<PrintResponse>(
      `${AppConstants.API_URL}api/Reports/DownloadFile?reportId=${reportId}`,
      { headers }
    );
  }

  GetReportUsers() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.get<ReportUsersResponse>(
      `${AppConstants.API_URL}api/ReportUser/GetReportUsers`,
      { headers }
    );
  }

  DeleteReport(reportId: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Authorization: `Bearer ${token.access_token}`
    });

    return this.http.delete<BaseResponse>(
      `${AppConstants.API_URL}api/Reports/DeleteReport?reportId=${reportId}`,
      { headers }
    );
  }
}
